import { BaseModel } from '../../_base/crud';

export class FollowupReason extends BaseModel {
  id: number;
  name: string;
}
